import { Injectable } from '@angular/core'
import { color as d3color, hsl } from 'd3-color'
import cloneDeep from 'lodash/cloneDeep'

@Injectable({
    providedIn: 'root',
})
export class MapColorGeneratorService {
    private readonly seed: Array<ISeedElement> = []
    private colors: Array<ISeedElement> = []

    constructor() {
        this.seed = [
            this.createSeedElem('#98EB7D', '#36BA0C', '#36ba0c', 0.55),
            this.createSeedElem('#ff8852', '#FF4800', '#ff4800', 0.67),
            this.createSeedElem('#94FBE6', '#10DDC7', '#16EBD4', 0.55),
            this.createSeedElem('#A644FA', '#6000B2', '#8A00FF', 0.55),
            this.createSeedElem('#FF4040', '#D10000', '#EE0000', 0.67),
            this.createSeedElem('#6EB2F1', '#0070D7', '#0070D7', 0.55),
            this.createSeedElem('#F84DB9', '#C6007D', '#E60995', 0.55)
        ]
    }


    public generateColorList(numOfColors: number): Array<ISeedElement> {
        this.generateColors(numOfColors, this.seed)

        return this.colors
    }

    public getColorList(): Array<ISeedElement> {
        return cloneDeep(this.colors)
    }

    public getHexColor(color: string): string {
        return d3color(color).formatHex()
    }

    public getMapLayerIconStyle(fill: string, stroke: string): string {
        // because of IE
        const icon = `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='-1 -1 20 20' preserveAspectRatio='xMinYMin meet'> <polygon fill='` + fill +
            `' stroke='` + stroke + `' points='5.8 0 9.6 0.6 9.6 2.1 12.2 2.1 16.6 3.8 15.1 6.8 18 11.6 17.3 15.4 12.8 15.8 9.6 17.9 4.9 17.1 5 15.6 1.6 15.3 0 12.2 2.4 10.1 0.6 6.9 2.4 6.2 3.4 2.6' /></svg>`

        const encodedIcon = encodeURIComponent(icon)

        return 'url("data:image/svg+xml,' + encodedIcon + '")'
    }

    /**********************************************************/

    private generateColors(num: number, seed: Array<ISeedElement>): void {
        if (this.colors.length >= num) {
            return
        } else {
            const seedB = this.transformColors(1.2, seed)
            const seedD = this.transformColors(0.8, seed)

            this.colors = [...this.colors, ...seedD, ...seedB]

            this.generateColors(num, seedD)
            this.generateColors(num, seedB)
        }
    }

    private transformColors(k: number, seedList: Array<ISeedElement>): Array<ISeedElement> {
        return seedList.map(color => this.transformColor(k, color))
    }

    private transformColor(k: number, seedElem: ISeedElement): ISeedElement {
        return this.createSeedElem(this.transformOneColor(k, seedElem.fill),
            this.transformOneColor(k, seedElem.stroke),
            this.transformOneColor(k, seedElem.mapColor),
            seedElem.mapOpacity
        )
    }

    private transformOneColor(k: number, colorCode: string): string {
        const d3c = hsl(colorCode)
        d3c.l = d3c.l * (k)

        return d3c.toString()
    }

    private createSeedElem(fill: string, stroke: string, mapColor: string, mapOpacity: number): ISeedElement {
        return {
            fill: fill,
            stroke: stroke,
            mapColor: mapColor,
            mapOpacity: mapOpacity
        }
    }

    private rgbToHex(r: number, g: number, b: number): string {
        return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b)
    }

    private componentToHex(c: number): string {
        let hex = c.toString(16)
        return hex.length === 1 ? '0' + hex : hex
    }
}

export interface ISeedElement {
    fill: string;
    stroke: string;
    mapColor: string;
    mapOpacity: number;
}